(function(){
  var w = document.getElementById('amo-wrap'); if(!w) return;

  /* id, plan and prices: window.ADAPTORY (snippets/adaptory-config.liquid) */
  var A = window.ADAPTORY;
  var MAG  = { id:A.mag.id, plan:A.mag.plan };
  var PRICE= { once:A.mag.once, sub:A.mag.sub, list:A.mag.compare };

  var isSub = true;

  function money(n){ return '$' + n.toFixed(2); }

  function render(){
    document.getElementById('amoSub').classList.toggle('on', isSub);
    document.getElementById('amoOnce').classList.toggle('on', !isSub);
    var p = isSub ? PRICE.sub : PRICE.once;
    document.getElementById('amoCta').textContent = 'Add to cart · ' + money(p);
    document.getElementById('amoTop').innerHTML = isSub
      ? money(PRICE.sub) + ' <s>' + money(PRICE.list) + '</s><span>per month</span>'
      : money(PRICE.once) + ' <s>' + money(PRICE.list) + '</s><span>one time</span>';
  }

  window.amoPick = function(sub){ isSub = !!sub; render(); };

  window.amoAcc = function(btn){
    var item = btn.parentElement, body = btn.nextElementSibling, open = item.classList.contains('open');
    w.querySelectorAll('.ai').forEach(function(i){
      i.classList.remove('open');
      var b = i.querySelector('.ab'); if(b) b.style.maxHeight = null;
    });
    if(!open){ item.classList.add('open'); body.style.maxHeight = body.scrollHeight + 'px'; }
  };

  window.amoAdd = function(){
    var item = { id:MAG.id, quantity:1 };
    if(isSub) item.selling_plan = MAG.plan;
    try{
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[item]})})
      .then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(function(){ if(window.acdOpen){ window.acdOpen(); } else { window.location.href='/cart'; } })
      .catch(function(e){ console.warn('Cart add works inside Shopify only:', e); });
    }catch(e){}
  };

  window.addEventListener('resize', function(){
    var o = w.querySelector('.ai.open .ab');
    if(o) o.style.maxHeight = o.scrollHeight + 'px';
  });

  render();
})();
